var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgField(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 4.375H7.4375V2.625H6.5625V4.375H4.8125V5.25H6.5625V7H7.4375V5.25H9.1875V4.375Z",
    fill: "#08A592"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 4.375H11.375V1.75C11.3748 1.51801 11.2825 1.29558 11.1185 1.13154C10.9544 0.967493 10.732 0.875232 10.5 0.875H3.5C3.26801 0.875232 3.04558 0.967493 2.88154 1.13154C2.71749 1.29558 2.62523 1.51801 2.625 1.75V4.375H1.75C1.51801 4.37523 1.29558 4.46749 1.13154 4.63154C0.967493 4.79558 0.875232 5.01801 0.875 5.25V13.125H13.125V5.25C13.1248 5.01801 13.0325 4.79558 12.8685 4.63154C12.7044 4.46749 12.482 4.37523 12.25 4.375ZM6.125 12.25V9.625H7.875V12.25H6.125ZM8.75 12.25V9.1875C8.75 9.07147 8.70391 8.96019 8.62186 8.87814C8.53981 8.79609 8.42853 8.75 8.3125 8.75H5.6875C5.57147 8.75 5.46019 8.79609 5.37814 8.87814C5.29609 8.96019 5.25 9.07147 5.25 9.1875V12.25H1.75V5.25H3.5V1.75H10.5V5.25H12.25V12.25H8.75Z",
    fill: "#08A592"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#08A592"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgField);
export default __webpack_public_path__ + "static/media/field.703f8455503153819ae3adbe493ab2a5.svg";
export { ForwardRef as ReactComponent };